import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
const companies = [{
  name: 'Google',
  chip: 'TPUv7 Ironwood',
  type: 'Gemini Inference',
  color: 'bg-blue-500'
}, {
  name: 'Amazon',
  chip: 'Trainium + Inferentia',
  type: 'AWS Cloud',
  color: 'bg-orange-500'
}, {
  name: 'Meta',
  chip: 'MTIA',
  type: 'Recommendation Models',
  color: 'bg-blue-600'
}, {
  name: 'Microsoft',
  chip: 'Maia',
  type: 'Azure AI',
  color: 'bg-blue-400'
}, {
  name: 'Anthropic',
  chip: 'TPU Customer',
  type: 'Model Training',
  color: 'bg-stone-200 text-black'
}, {
  name: 'xAI',
  chip: 'TPU Customer',
  type: 'Grok',
  color: 'bg-white text-black'
}];
export function HyperscalerSlide() {
  return <SlideLayout slideNumber={6} totalSlides={20} title="The Hyperscaler Carve-Out" data-id="element-309">
      <div className="w-full h-full flex flex-col" data-id="element-310">
        <div className="text-center mb-5" data-id="element-311">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-bold mb-2" data-id="element-312">
            The Big Players Are Leaving GPUs
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl text-brand-muted" data-id="element-313">
            Hyperscalers are building their own silicon to cut costs and reduce
            dependency on Nvidia.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1" data-id="element-314">
          {companies.map((company, index) => <motion.div key={company.name} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="bg-brand-surface border border-brand-border p-6 rounded-xl flex flex-col justify-center" data-id="element-315">
              <div className="flex items-center gap-3 mb-4" data-id="element-316">
                <div className={`w-11 h-11 rounded-full ${company.color} flex items-center justify-center font-bold text-base shrink-0`} data-id="element-317">
                  {company.name[0]}
                </div>
                <h3 className="font-bold text-2xl" data-id="element-318">{company.name}</h3>
              </div>
              <div className="space-y-1" data-id="element-319">
                <div className="text-base text-brand-muted uppercase tracking-wider font-mono" data-id="element-320">
                  Chip / Strategy
                </div>
                <div className="font-semibold text-brand-primary text-xl" data-id="element-321">
                  {company.chip}
                </div>
                <div className="text-xl text-brand-muted" data-id="element-322">{company.type}</div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-4 p-5 bg-brand-surface/50 border border-brand-border rounded-xl text-center" data-id="element-323">
          <p className="text-brand-muted text-xl italic" data-id="element-324">
            "Nvidia's actual share of AI compute cycles is meaningfully lower
            than its share of chip sales."
          </p>
        </motion.div>
      </div>
    </SlideLayout>;
}